module.exports = function getResource(label, vars = []) {
    const resources = {
        beautyServices: 'Beauty Services FAQ',
        happeningAtSephora: 'Happening at Sephora',
        makeupServices: 'Makeup Services'
    };

    return resources[label];
};
